import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { JoinPage, LoadingPage, ResetPasswordPage } from "routes";

import { LoginPage } from "./auth/login";
import { ANY_OTHER, JOIN, LOGIN, RESET_PASSWORD } from "./consts";

export const PublicRoutes = () => (
  <Suspense fallback={<LoadingPage />}>
    <Routes>
      <Route path={LOGIN} element={<LoginPage />} />
      <Route path={JOIN} element={<JoinPage />} />
      <Route path={RESET_PASSWORD} element={<ResetPasswordPage />} />

      <Route path={ANY_OTHER} element={<Navigate to={LOGIN} replace />} />
    </Routes>
  </Suspense>
);
